import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  ["When should my child first see a dentist?", "Ideally by the first birthday, or within six months of the first tooth appearing. Early visits are short, friendly and help your child feel at home."],
  ["How does the online consultation work?", "Choose 'Online consultation' while booking and pick a time. Once the clinic confirms, you'll receive a video meeting link by email and on your 'My visits' page."],
  ["Do you treat children with special needs?", "Yes. Tooth Buds specialises in infants, toddlers, teens and special children, with extra time and patience for every visit."],
  ["What should I do in a dental emergency?", "Call us right away on +91 98206 49411. For a knocked-out permanent tooth, hold it by the crown, keep it in milk and come in within 30 minutes."],
  ["What are your clinic hours?", "Monday to Saturday, 10 AM–1 PM and 5–9 PM. We're closed on Sundays."],
];

export const Faq = () => (
  <section className="mx-auto max-w-4xl px-6 py-20" data-testid="faq-section">
    <span className="text-xs font-bold uppercase tracking-widest text-teal-600">Good to know</span>
    <h2 className="mt-3 text-3xl font-bold tracking-tight sm:text-4xl">Parents often ask</h2>
    <Accordion type="single" collapsible className="mt-8 space-y-3">
      {FAQS.map(([q, a], i) => (
        <AccordionItem key={q} value={`f${i}`} className="rounded-2xl border border-slate-200 bg-white px-6" data-testid={`faq-item-${i}`}>
          <AccordionTrigger className="font-display text-left text-lg font-semibold text-slate-800 hover:no-underline">{q}</AccordionTrigger>
          <AccordionContent className="text-slate-600">{a}</AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  </section>
);
